export default String.raw`
<div class="product-coupons-list">    
    <div class="product-coupons-items coupons-items-js"></div>
    
    <div class="show-more-button-container show-more-container-js" style="display: none;">
        <button class="pure-button show-more-coupons-btn show-more-coupons-product-list" 
                type="button" 
                >
            {{ translations.ShowMoreDiscounts }} (<span class="total-count-js">0</span>)
        </button>
    </div>
</div>

<div class="product-coupon-item coupon-template-js" style="display: none;">
    <div class="coupon-content">
        <div class="coupon-icon-container">
            <div class="coupon-icon coupon-icon-js"></div>
        </div>
        <div class="coupon-name coupon-name-js"></div>
    </div>
</div>
`